import BlockType from './BlockType'
import Controls from './Controls'

/**
 * Loader
 * 
 * @namespace GB.Loader
 * @returns {Loader}
 */
export default class Loader {
    /**
     * Loads all Blocks from array
     * 
     * @param {array} blocks
     * @param {string} category
     */
    static load(blocks, category = null) {
        // Options array
        if (Array.isArray(blocks)) {
            blocks.forEach(block => Loader.register(block))
            return
        }

        // esModule
        for(let title in blocks) {
            Loader.register({
                'category': category,
                'title': title,
                'component': blocks[title],
            })
        }
    }

    /**
     * BlockType Single Block
     * 
     * @param {object} block
     */
    static register(block) {
        if (! block) throw 'Loader requires a component to register'

        // Transform Component object to BlockType options
        if (! block.component) block = {component: block}

        let reg = new BlockType(block)
        reg.register()
    }

    /**
     * Registers block controls, accepts multiple
     * 
     * @param {string|array} block
     * @param {array} controls
     */
    static controls(block, controls) {
        if (Array.isArray(block)) {
            block.forEach(block => Loader.controls(block, controls))
            return
        }

        Controls.register(block, controls)
    }
}